import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import NavigationDropdownMenu from '../../common/NavigationDropdownMenu';

const HeaderNavMenu = ({ surface, className, toggleClassName, ...rest }) => {
  return (
    <NavigationDropdownMenu
      className={classNames(
        'HeaderNavMenu',
        `HeaderNavMenu--${surface}`,
        className
      )}
      toggleClassName={classNames(
        'HeaderNavMenu__toggle',
        `HeaderNavMenu__toggle--${surface}`,
        toggleClassName
      )}
      {...rest}
    />
  );
};

HeaderNavMenu.propTypes = {
  surface: PropTypes.oneOf(['top', 'bottom']).isRequired,
  className: PropTypes.string,
  toggleClassName: PropTypes.string,
};

HeaderNavMenu.defaultProps = {
  className: '',
  toggleClassName: '',
};

export default HeaderNavMenu;
